// extracted by mini-css-extract-plugin
export default {"-large":"gGh5pfY1QuQIZmqZZgWu","container":"_4Q2MzCixAZPP6gkySB0F","upperContainer":"LWQqhT6tj1WU2L8LEjt1"};